import request from '@/utils/service'

export function login(username, password) {
  const data = { account: username, password }

  return request({
    url: '/login',
    method: 'post',
    data
  })
}

export function getUserInfo() {
  return request({ url: '/userinfo', method: 'post', data: {} })
}

export function logout() {
  return request({
    url: '/logout',
    method: 'post',
    data: {}
  })
}

export function changePassword(data) {
  return request({
    url: '/mgr/changePwd',
    method: 'post',
    data
  })
}

export function changeAuditPwd(data) {
  return request({
    url: '/changeAuditPassword',
    method: 'post',
    data
  })
}
